import config from '../../config.js';
import products from '../../utils/products.js';
//todo change labels
import fieldUtils from '../../utils/step.fields.utils.js';

const secondOccupation = () => {
    return [
        {
            key: `occupation_1_type`
        },
    ];
};
const drivers = (n) => {
    const result = [
        {...fieldUtils.driver_x_name(n)},
        {...fieldUtils.driver_x_relationship(n)}
    ];

    if (n < config[products.taxi].drivers - 1) {
        result.push({
            ...fieldUtils.driver_x_more(n),
            label: 'Are any additional drivers required on the policy?',
            children: drivers(n + 1),
            required_children: value => value === true
        });
    }
    return result;
};
const claims = (driver, n) => {
    const result = [
        {...fieldUtils.claim_x_type(driver, n)},
        {...fieldUtils.claim_x_date(driver, n)}
    ];

    if (n < config[products.taxi].claims - 1) {
        result.push({
            ...fieldUtils.claim_x_more(driver, n),
            children: claims(driver, n + 1),
            required_children: value => value === true
        });
    }
    return result;
};

const convictions = (driver, n) => {
    const result = [
        {...fieldUtils.conviction_x_type(driver, n)},
        {...fieldUtils.conviction_x_ban(driver, n)}
    ];

    if (n < config[products.taxi].mot_convictions - 1) {
        result.push({
            ...fieldUtils.conviction_x_more(driver, n),
            children: convictions(driver, n + 1),
            required_children: value => value === true,
        });
    }
    return result;
};

const step_schema_taxi = [
    //Vehicle
    //-----------
    {
        key: 'vrm'
    },
    {
        key: 'make',
        required: true,
        skip_question: true
    },
    {
        key: 'model',
        skip_question: true,
    },
    {
        key: 'year',
        required: true,
        skip_question: true
    },
    {
        key: 'body_type'
    },
    {
        key: 'owner'
    },
    {
        key: 'ncb_years_private'
    },
    {
        key: 'ncb_years_taxi'
    },
    {
        key: 'seats'
    },
    {
        key: 'value',
        label: 'What is the vehicle value?'
    },
    {
        key: 'private_hire',
        children: [
            {
                key: 'taxi_uber',
                required_if: parent_value => parent_value === true
            },
        ],
    },
    {
        key: 'public_hire'
    },
    {
        key: 'taxi_badge_year'
    },
    {
        key: 'number_of_vehicles',
        label: 'How many taxi vehicles do you want to insure?',
        value: 1
    },
    {
        key: 'taxi_psv_licence'
    },
    {
        key: 'taxi_pco_licence'
    },
    //Driver
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        key: 'telephone'
    },
    {
        key: 'email'
    },
    {
        key: 'date_of_birth'
    },
    {
        key: 'postcode'
    },
    {
        key: 'address1',
        skip_question: true
    },
    {
        key: 'address2',
        skip_question: true,
    },
    {
        key: 'address3',
        skip_question: true,
    },
    {
        key: 'address4',
        skip_question: true,
    },
    {
        key: 'city',
        skip_question: true,
    },
    {
        key: 'uk_since',
        children: [
            {
                key: 'uk_since_date',
                required_if: parent_value => parent_value === false
            },
        ],
    },
    {
        key: 'taxi_council'
    },
    {
        key: 'licence_type'
    },
    {
        key: 'licence_date'
    },
    {
        key: 'occupation_0_type',
        value: 'taxi driver'
    },
    {
        key: 'occupation_0_more',
        label: 'Do you have any additional occupation?',
        children: secondOccupation(),
        required_children: value => value === true
    },
    {
        key: 'has_convictions_more',
        label: 'Have you had any motoring convictions in the last 5 years?',
        children: convictions(`Proposer's`, 0),
        required_children: value => value === true
    },
    {
        key: 'has_claims_more',
        label: 'Have you made any claims in the last 5 years?',
        children: claims('Proposer\'s', 0),
        required_children: value => value === true
    },
    {
        key: 'has_another_driver_more',
        label: 'Do you want to insure any additional drivers on the policy?',
        children: drivers(0),
        required_children: value => value === true
    },
    //policy
    {
        key: 'cover_date',
    },
    {
        key: 'cover_duration',
        label: 'Are you looking for a 12 months insurance policy?'
    },
    {
        key: 'marketing',
        extra_children: [
            {key: 'marketing_phone'},
            {key: 'marketing_email'},
            {key: 'marketing_sms'}
        ]
    },
    {
        key: 'end',
    },
];
export default step_schema_taxi;
